<template src="./template.html"></template>
<style src="./styles.scss" scoped lang="scss"></style>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'AppBar',
    computed: {
      ...mapState('auth', ['settings']),
    },
  }
</script>
